module.exports = __webpack_public_path__ + "static/media/the-container-store-small_2x.4b13eaaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/the-container-store-small_2x.png
// module id = 858
// module chunks = 27